import { useListPager } from '@airship-platform/airship-patterns';
import { FlexBox } from '@airship-platform/jam-web/components';
import Box from '@mui/material/Box';
import React, { useState } from 'react';
import { DiscountAndFee } from '../../../data-access';
import ModifierCard from './ModifierCard';

type ModifiersListProps = {
  availableRebates: Array<
    DiscountAndFee & {
      actions: React.ReactNode;
    }
  >;
};

const ModifiersList: React.FC<ModifiersListProps> = ({ availableRebates }) => {
  const [pageCounter, setPageCounter] = useState(20);

  const { loaderRef } = useListPager({
    incrementBy: 20,
    initialValue: pageCounter,
    maxValue: availableRebates.length,
    callbackFn: setPageCounter,
  });

  const pagedRebates = availableRebates.slice(0, pageCounter);

  return (
    <FlexBox flexDirection={'column'} gap={2}>
      {pagedRebates.map((modifier) => (
        <FlexBox
          flexDirection={'column'}
          gap={2}
          key={modifier.discountsAndFeesId}
        >
          <ModifierCard modifier={modifier}>{modifier.actions}</ModifierCard>
        </FlexBox>
      ))}

      <Box ref={loaderRef} sx={{ height: 50 }} />
    </FlexBox>
  );
};

export default ModifiersList;
